import { createPortal } from "react-dom";

import { useFixedActionButtons } from "./FixedActionButtonsContext";
import { Desktop, NonDesktop } from "../Utils/ResponsiveQueries";

const FixedActionButton = props => {
  const { children } = props;
  const { buttonsContainer } = useFixedActionButtons();

  return (
    <>
      <Desktop>{children}</Desktop>

      {buttonsContainer && (
        <NonDesktop>{createPortal(children, buttonsContainer)}</NonDesktop>
      )}
    </>
  );
};

export default FixedActionButton;
